export default "__VITE_ASSET__CXofAd8l__"